import { createTheme } from '@mui/material/styles';
import { colors, shape, typography, glass } from '@/design-system/tokens';
const shared = {
    shape: { borderRadius: shape.corner.md },
    typography: {
        fontFamily: typography.family.body,
        h1: { fontFamily: typography.family.display, fontWeight: 700, letterSpacing: -1.5 },
        h2: { fontFamily: typography.family.display, fontWeight: 700, letterSpacing: -0.5 },
        h3: { fontFamily: typography.family.display, fontWeight: 600, letterSpacing: -0.25 },
        button: { textTransform: 'none', fontWeight: 600 },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: { minHeight: 40, paddingInline: 20, borderRadius: shape.corner.full },
                containedPrimary: {
                    background: `linear-gradient(135deg, ${colors.brand.teal[40]}, ${colors.brand.teal.accent})`,
                    position: 'relative',
                    overflow: 'hidden',
                    '&::after': {
                        content: '""',
                        position: 'absolute',
                        inset: 0,
                        background: 'linear-gradient(105deg, transparent 40%, rgba(255,255,255,0.25) 45%, rgba(255,255,255,0.25) 55%, transparent 60%)',
                        transform: 'translateX(-100%)',
                        transition: 'transform 600ms ease',
                    },
                    '&:hover::after': {
                        transform: 'translateX(100%)',
                    },
                    '@media (prefers-reduced-motion: reduce)': {
                        '&::after': { display: 'none' },
                    },
                },
            },
        },
        MuiTextField: {
            defaultProps: { variant: 'outlined', fullWidth: true },
        },
        MuiCard: {
            styleOverrides: { root: { borderRadius: shape.corner.lg } },
        },
        MuiChip: {
            styleOverrides: { root: { borderRadius: shape.corner.sm } },
        },
    },
};
export const lightTheme = createTheme({
    ...shared,
    palette: {
        mode: 'light',
        primary: { main: colors.brand.teal[40], contrastText: '#fff' },
        secondary: { main: colors.brand.graphite[40], contrastText: '#fff' },
        error: { main: colors.brand.error[40] },
        warning: { main: colors.brand.citrus[60] },
        background: { default: colors.brand.graphite[99], paper: '#fff' },
        text: { primary: colors.brand.graphite[10], secondary: colors.brand.graphite[40] },
    },
    components: {
        ...shared.components,
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: shape.corner.lg,
                    background: glass.light.background,
                    backdropFilter: `blur(${glass.light.blur}px)`,
                    border: `1px solid ${glass.light.border}`,
                },
            },
        },
    },
});
export const darkTheme = createTheme({
    ...shared,
    palette: {
        mode: 'dark',
        primary: { main: colors.brand.teal[70] },
        secondary: { main: colors.brand.graphite[80] },
        error: { main: colors.brand.error[60] },
        warning: { main: colors.brand.citrus[60] },
        background: { default: '#0F1114', paper: colors.brand.graphite[20] },
        text: { primary: colors.brand.graphite[99], secondary: colors.brand.graphite[80] },
    },
    components: {
        ...shared.components,
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: shape.corner.lg,
                    background: glass.dark.background,
                    backdropFilter: `blur(${glass.dark.blur}px)`,
                    border: `1px solid ${glass.dark.border}`,
                },
            },
        },
    },
});
